"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupHisaiRegisterReducer = exports.groupHisaiRegisterActions = exports.TYPES = exports.INIT_STATE = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Register';

// アクションタイプ
const TYPES = exports.TYPES = {
  // ラジオボタン状態変更
  CHANGE_RADIO: PREFIX + 'ChangeRadio',
  // クリア
  CLEAR: PREFIX + 'Clear'
};

// 初期状態
const INIT_STATE = exports.INIT_STATE = {
  selectHisaiKbnCd: '',
  // ラジオボタンで選択した被災情報区分コード
  selectHisaiKbnNm: '' // ラジオボタンで選択した被災情報区分
};

// アクション生成
const groupHisaiRegisterActions = exports.groupHisaiRegisterActions = (0, _reduxActions.createActions)({
  // ラジオボタン状態変更
  [TYPES.CHANGE_RADIO]: function () {
    return {
      id: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  }
},
// クリア
TYPES.CLEAR);
const groupHisaiRegisterReducer = exports.groupHisaiRegisterReducer = (0, _reduxActions.handleActions)({
  // ラジオボタン状態変更
  [TYPES.CHANGE_RADIO]: (state, action) => {
    const {
      id,
      value
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      selectHisaiKbnCd: id,
      selectHisaiKbnNm: value
    });
  },
  // クリア
  [TYPES.CLEAR]: (state, action) => INIT_STATE
}, INIT_STATE);